import { useEffect, useState } from "react";

import ReactGA from "react-ga4";
import { useLocation } from "react-router-dom";

import { getCurrentLang } from "@/utils/Local";

const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID ?? null;
const conversionId = import.meta.env.VITE_GA_CONVERSION_ID ?? null;
const conversionLabel = import.meta.env.VITE_GA_CONVERSION_LABEL ?? null;

const useGaTracker = () => {
  const { pathname } = useLocation();
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (import.meta.env.MODE !== "development" && measurementId) {
      ReactGA.initialize(measurementId);
      setInitialized(true);
    }
  }, []);

  useEffect(() => {
    if (initialized) {
      const object = { hitType: "pageview", page: pathname };
      ReactGA.ga("send", object);
      if (conversionId && conversionLabel) {
        ReactGA.gtag("config", conversionId);
      }
    }
  }, [initialized, pathname]);
};

export default useGaTracker;

export const trackEvent = (action: string, params?: {}) => {
  if (import.meta.env.MODE === "development" || !conversionId) {
    console.log(`GA event | action: ${action}`);
  } else {
    const data = {
      page_path: window.location.pathname,
      lang: getCurrentLang(),
      ...params,
    };
    ReactGA.event(action, data);
  }
};

export const trackConversion = () => {
  if (!conversionId || !conversionLabel) {
    return;
  }
  ReactGA.gtag("event", "conversion", {
    send_to: `${conversionId}/${conversionLabel}`,
    value: 1,
    currency: "CAD",
  });
};
